import { VideoEditorLogger } from '../../utility/VideoEditorLogger';
import { AbstractLayoutCommand } from './AbstractLayoutCommand';
import { TimelineMode } from './TimelineMode';

export class DeleteLayoutElementsCommand extends AbstractLayoutCommand {
  getName(): string {
    return 'DeleteLayoutElementsCommand';
  }

  execute(): boolean {
    if (!this.sourceElement) {
      VideoEditorLogger.logCommand(this, 'error', {
        error: 'No source element provided',
      });
      return false;
    }

    super.execute(); // makes a snapshot

    const elements = this.pickAllLayoutElements(this.sourceElement);
    if (!elements) {
      VideoEditorLogger.logCommand(this, 'error', {
        error:
          'Failed to remove parent: no parent found or not a layout element',
      });
      return false;
    }
    const { parent: parentElement, children: childrenElements } = elements;

    // Delete each associated element
    for (const linkedElement of childrenElements) {
      // Clean up extraElementData for the composition element
      this.extraElementData.removeElementData(linkedElement.id);

      // Delete the actual element
      const success = this.editor
        .getTrackManager()
        .removeElement(linkedElement, TimelineMode.DEFAULT);
      if (!success) {
        VideoEditorLogger.logCommand(this, 'error', {
          error: `Failed to remove element with ID ${linkedElement.id}`,
        });
        return false;
      }
    }

    this.extraElementData.clearLayoutData(parentElement);
    const removeParentSuccess = this.editor
      .getTrackManager()
      .removeElement(parentElement, TimelineMode.RIPPLE);
    if (!removeParentSuccess) {
      VideoEditorLogger.logCommand(this, 'error', {
        error: `Failed to remove parent element ${parentElement.id}`,
      });
      return false;
    }

    this.canUndo = true;

    return true;
  }

  getDescription(): string {
    return `removing layout element`;
  }
}
